import {combineReducers} from 'redux'
import authReducer from 'redux/reducer/authReducer'
import cfsReducer from 'redux/reducer/cfsReducer'
import globalSettingsReducer from 'redux/reducer/globalSettingsReducer'

export default combineReducers({
  auth: authReducer,
  globalSettings: globalSettingsReducer,
  cfs: cfsReducer,
})
